import type { DefaultPlan } from 'payments/payments-dialog/lib/plans'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import { formatNumberToNumericalAbreviation } from 'utils/number'
import { PurchaseCard } from './purchase-card'
import type { PurchaseCardVariant } from './purchase-card'

interface SubscriptionCardProps {
  coins: number
  price: string
  unitPrice: string
  variant?: PurchaseCardVariant
  plan: DefaultPlan
  onSelectPlan: (plan: DefaultPlan) => void
  isUpgrade?: boolean
  loading?: boolean
  success?: boolean
  isHighestValue?: boolean
}

export function SubscriptionCard({
  coins,
  price,
  unitPrice,
  variant = 'default',
  plan,
  onSelectPlan,
  isUpgrade = false,
  loading = false,
  success = false,
  isHighestValue = false,
}: SubscriptionCardProps) {
  const t = useStudioTranslate()

  return (
    <PurchaseCard.Root variant={variant}>
      <PurchaseCard.Title variant={variant}>
        <span className="no-display lg:block">
          {t('studio.coins.top_up_dialog.coins_label', {
            amount: coins.toLocaleString(),
          })}
        </span>
        <span className="lg:no-display">
          {t('studio.coins.top_up_dialog.coins_label', {
            amount: formatNumberToNumericalAbreviation(coins),
          })}
        </span>
      </PurchaseCard.Title>

      <PurchaseCard.Price
        variant={variant}
        price={price}
        suffix={t('studio.coins.top_up_dialog.per_month')}
      />
      <PurchaseCard.UnitPrice variant={variant}>{unitPrice}</PurchaseCard.UnitPrice>
      <PurchaseCard.BuyButton
        variant={variant}
        onClick={() => onSelectPlan(plan)}
        disabled={loading || success}
        success={success}
        isHighestValue={isHighestValue}
      >
        {isUpgrade
          ? t('studio.coins.top_up_dialog.subscriptions.upgrade')
          : t('studio.coins.top_up_dialog.subscriptions.activate')}
      </PurchaseCard.BuyButton>
    </PurchaseCard.Root>
  )
}
